import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { CTASection } from '../components/CTASection';
import { cases } from '../data/mockData';
import { PageHero } from '../components/PageHero';
export function Cases() {
  return <main className="w-full bg-off-white" data-id="element-436">
      <PageHero label="Onze resultaten" title="Cases" subtitle="Ontdek hoe wij ondernemers hebben geholpen met objectieve, professionele bedrijfswaarderingen in uiteenlopende situaties." data-id="element-437" />

      <section className="py-24" data-id="element-438">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-439">
          <AnimatedSection className="mb-16 max-w-3xl" data-id="element-440">
            <h2 className="text-3xl font-light text-charcoal mb-4" data-id="element-441">Praktijkvoorbeelden van succesvolle waarderingen</h2>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-442">Een objectieve waardering vormt de basis voor succesvolle transacties en strategische beslissingen. In onderstaande cases leest u hoe wij ondernemers hebben geholpen met een professionele{' '}
              <Link to="/bedrijfswaardering" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-443">bedrijfswaardering</Link>{' '}in diverse complexe situaties.
            </p>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-444">
            {cases.map((caseItem, index) => <AnimatedSection key={caseItem.id} delay={index * 0.1} data-id="element-445">
                <Link to={`/cases/${caseItem.slug}`} className="group block h-full" data-id="element-446">
                  <div className="bg-white rounded-2xl overflow-hidden border border-warm-gray/50 shadow-sm hover:shadow-lg transition-all duration-300 h-full flex flex-col" data-id="element-447">
                    <div className="h-52 overflow-hidden bg-warm-gray" data-id="element-448">
                      <img src={caseItem.image} alt={caseItem.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-449" />
                    </div>
                    <div className="p-8 flex flex-col flex-grow" data-id="element-450">
                      <h3 className="text-xl font-medium mb-3 text-charcoal group-hover:text-accent transition-colors" data-id="element-451">{caseItem.title}</h3>
                      <p className="text-charcoal/70 text-sm leading-relaxed mb-6 flex-grow line-clamp-3" data-id="element-452">{caseItem.situatie}</p>
                      <div className="flex items-center text-accent text-sm font-medium mt-auto" data-id="element-453">Bekijk case <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-454" /></div>
                    </div>
                  </div>
                </Link>
              </AnimatedSection>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-455" />
    </main>;
}